// src/services/_headers.util.js
import { authHeader } from "./auth-headerService";
import { shouldSendCompanyHeader } from "@/utils/hostname";

export const ACTIVE_COMPANY_KEY = "activeCompanyId";

/** Get the active company id from localStorage (or null) */
export function getActiveCompanyId() {
  const id = localStorage.getItem(ACTIVE_COMPANY_KEY);
  return id ? Number(id) : null;
}

/** Persist the active company id (number or null) */
export function setActiveCompanyId(id) {
  if (id === null || id === undefined || id === "") {
    localStorage.removeItem(ACTIVE_COMPANY_KEY);
  } else {
    localStorage.setItem(ACTIVE_COMPANY_KEY, String(id));
  }
}

/** Remove any stored active company id */
export function clearActiveCompanyId() {
  localStorage.removeItem(ACTIVE_COMPANY_KEY);
}

/**
 * Build request headers:
 * - Merges auth headers
 * - Injects X-Company-ID (from arg or from localStorage if present)
 * - Optionally removes Content-Type for FormData
 *
 * Flexible params:
 *   buildHeaders(extra, companyId)
 *   buildHeaders(extra, { companyId, multipart })
 */

export function buildHeaders(extra = {}, companyOrOptions = null, options = {}) {
  let companyId = null;
  let multipart = false;

  // Overload-friendly: accept either companyId or an options object in 2nd param
  if (typeof companyOrOptions === "object" && companyOrOptions !== null) {
    options = companyOrOptions;
  } else {
    companyId = companyOrOptions;
  }

  if (options && typeof options === "object") {
    if (options.companyId !== undefined && options.companyId !== null) {
      companyId = options.companyId;
    }
    if (options.multipart === true) {
      multipart = true;
    }
  }

  const headers = authHeader() || {};

  // If multipart, let Axios set the correct boundary automatically
  if (multipart && headers["Content-Type"]) {
    delete headers["Content-Type"];
  }

  // Prefer explicit companyId; else fall back to stored one (legacy shared DB mode only)
  const active = companyId ?? getActiveCompanyId();
  if (active && shouldSendCompanyHeader()) {
    headers["X-Company-ID"] = active;
  }

  // Helpful for Laravel/Sanctum / CSRF setups
  headers["X-Requested-With"] = "XMLHttpRequest";

  return { ...headers, ...extra };
}
